var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("编辑条款"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 1000,
      maskClosable: false,
      closable: false
    },
    on: {
      ok: _vm.handleSure,
      cancel: _vm.cancelFun
    }
  }, [_c("a-form-model", {
    ref: "termsRef",
    attrs: {
      model: _vm.termsForm,
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 19
      },
      rules: _vm.type == 1 ? _vm.TERMRULE2 : _vm.TERMRULE
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    model: {
      value: _vm.termsForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.termsForm, "name", $$v);
      },
      expression: "termsForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("条款文件"),
      prop: "linkName"
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.uploadFile,
      multiple: false,
      showUploadList: {
        showRemoveIcon: false
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      data: {
        module: "insuranceTerms"
      },
      accept: ".pdf",
      "before-upload": _vm.beforeUpload,
      disabled: _vm.uploadStatus,
      fileList: _vm.fileList
    },
    on: {
      change: _vm.handleChange
    }
  }, [_c("a-button", [_c("a-icon", {
    attrs: {
      type: "upload"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("选择文件")) + " ")], 1)], 1), _c("span", {
    staticStyle: {
      color: "#f5222d"
    }
  }, [_vm._v("*" + _vm._s(_vm.$t("仅支持上传PDF格式文件，最大不超")) + _vm._s(_vm.type == 1 ? 10 : 5) + "M")])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文本内容"),
      prop: "content"
    }
  }, [_vm.showQuill ? _c("quill-editor", {
    staticStyle: {
      height: "400px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.termsForm.content,
      callback: function ($$v) {
        _vm.$set(_vm.termsForm, "content", $$v);
      },
      expression: "termsForm.content"
    }
  }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };